import { useEffect, useState } from 'react';
import type { IServiceActivity } from '@common/interfaces';
import { getServiceActivities } from '@frontend/services/api/servicesApiService';
import { useAbortSignal } from '@frontend/utils/hooks/useAbortSignal';
import {
    type IRequestCompensationPayoutListProps,
    RequestCompensationPayoutList,
} from './RequestCompensationPayoutList';
import { ServiceActivityCompensationPayoutList } from './ServiceActivityCompensationPayoutList';

export function CompensationPayoutList(props: IRequestCompensationPayoutListProps) {
    const abortSignal = useAbortSignal();
    const [serviceActivities, setServiceActivities] = useState<IServiceActivity[]>([]);

    useEffect(() => {
        if (props.serviceId) {
            loadServiceActivities(props.serviceId);
        }
    }, []);

    return serviceActivities.length ? (
        <ServiceActivityCompensationPayoutList {...props} />
    ) : (
        <RequestCompensationPayoutList {...props} />
    );

    async function loadServiceActivities(serviceId: string) {
        const result = await getServiceActivities(serviceId, abortSignal);

        setServiceActivities(result);
    }
}
